import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Table, TableContainer, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export const MainTable = styled(Table)(() => ({
    width: "100%",
    "& .MuiTableCell-root": {
        borderBottom: "none",
    },
}));


export const AccordionTable = styled(TableContainer)(() => ({
    // paddingBlock: "10px",
}));


export const MainButton = styled(Button)(() => ({
    border: "none",
    padding: "7px 45px",
    borderRadius: 20,
    textTransform: "inherit",
    fontFamily: 'Figtree, sans-serif',
    "&:hover": {
        border: "none",
    },
}));

export const CancelButton = styled(MainButton)(() => ({
    backgroundColor: "#e0e8ff",
    color: "#638dff",
    border: "none",
    fontFamily: 'Figtree, sans-serif',
    fontSize: 14,
    boxShadow: "none",
    "&:hover": {
        backgroundColor: "#eef2ff",
    },
    "&:focus": {
        boxShadow: "0 0 6px 0 rgba(99, 141, 255, 0.6)",
        backgroundColor: "#eef2ff",
    },
    "&:disabled": {
        backgroundColor: "#e8ecf8",
        color: "#aeb8d6",
        border: "none",
    },
}));

export const ConfirmButton = styled(MainButton)(() => ({
    backgroundColor: "#638dff",
    color: "#FFFFFF",
    fontFamily: "Roboto",
    fontSize: 14,
    boxShadow: "none",
    "&:hover": {
        backgroundColor: "#4c71d6",
    },
    "&:focus": {
        boxShadow: "0 0 6px 0 #638dff !important",
    },
    "&:disabled": {
        backgroundColor: "#aeb8d6",
        color: "#e8ecf8",
    },
}));

export const TitleTypography = styled(Typography)(() => ({
    color: "#44485A",
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    fontWeight: "normal !important"
}));

export const AccordionM = styled(
    (props) => <Accordion disableGutters elevation={0} square {...props} />,
    {
        shouldForwardProp: (prop) => prop !== 'hasNewUISection',
    }
)(({ hasNewUISection }) => ({
    alignSelf: 'center',
    margin: '5px 0',
    width: hasNewUISection ? '100%' : '100%',
    maxWidth: hasNewUISection ? '100%' : '1380px',
    "&:before": {
        display: "none",
    },
    "&.MuiAccordion-root:first-of-type": {
        marginBottom: "20px !important",
    },
}));


export const AccordionSummaryM = styled((props) => (
    <AccordionSummary
        expandIcon={
            !Boolean(props.disableiconflag) && (
                <ExpandMoreIcon
                    sx={{
                        fontSize: "1.75rem",
                        color: "#44485A",
                    }}
                />
            )
        }
        aria-controls="panel1d-content"
        id="panel1d-header"
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: "white",
    borderRadius: "10px",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIcon": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
        transform: "rotate(270deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: 8,
    },
    "& .MuiAccordionSummary-content > .MuiTypography-body1 ": {
        fontWeight: 600,
    },
}));


export const AccordionDetailsM = styled(AccordionDetails)(() => ({
    padding: "4px",
    borderTop: "0px",
    height: '100%',
    "& .MuiCollapse-wrapper": {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
    },
}));


export const Container = styled("div")(() => ({
    width: "60%",
    // paddingLeft: 16,
    minWidth: "max-content",
}));


export const StyledGrid = styled(Grid)({
    width: "100%",
    marginLeft: "14px !important",
});


const BaseDiv = ({ iscollection, ...rest }) => <div {...rest} />;

export const SpaceSettler = styled(BaseDiv)((props) => ({
    margin: props.iscollection ? "20px" : "15px"
}));